import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import styles from './index.module.less'
// import { useTranslation } from 'react-i18next'

export default function Loading(props: any) {
  const { color = '#306FDC' } = props
  // const { t } = useTranslation('common')
  const [tips, setTips] = useState('')
  const saveTime = new Date().getTime()
  useEffect(() => {
    // if (type === 'message') return;
    const timer = setInterval(() => {
      const nowTime = new Date().getTime()
      const useTime = nowTime - saveTime
      if (useTime >= 2000 && useTime < 5000) {
        setTips('努力加载中...')
      } else if (useTime >= 5000) {
        setTips('当前加载速度较慢，请稍候...')
        if (timer) clearInterval(timer)
      }
    }, 1000)
    return () => {
      if (timer) clearInterval(timer)
    }
  }, [])
  return (
    <div
    className={styles['joyspace-loading']}
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color }} />} />
      {tips && (
        <div
          style={{
            fontSize: '12px',
            marginTop: '42px',
            color: '#666666'
          }}
        >
          {tips}
        </div>
      )}
    </div>
  )
}
